<div class="modal-body">
  <div class="row mb-32">
    <div class="col-12" class="d-flex justify-content-center align-items-center">
      <img src="assets/img/shared/success-icon.png" class="" alt="">
    </div>
  </div>
  <div class="row">
    <div class="col-12 text-center poppins mb-32">
      <p class="header-text">Success!</p>
      <p class="sub-text">{{ message?.message }}</p>
    </div>
  </div>

  <div class="row">
    <div class="col-12 d-flex justify-content-evenly align-items-center poppins">
      <!-- <button type="button" class="btn-later" (click)="closeModal()">Later</button> -->
      <button type="button" class="btn-yes" (click)="dismiss()">Okay</button>
    </div>
  </div>
</div>
